module.exports = __webpack_public_path__ + "assets/img/banner.a813b7a3.jpg";